/* eslint-disable jsx-a11y/alt-text */
import React, { Component } from 'react';
import { Scrollbars } from 'react-custom-scrollbars-2';
import {
  FeedSummary,
  FeedLabel,
  FeedExtra,
  FeedEvent,
  FeedUser,
  FeedDate,
  FeedContent,
  Feed,
  Modal,
  Form,
  FormTextArea,
  Button,
  Header,
} from 'semantic-ui-react';
import { v4 as uuidv4 } from 'uuid';
import userPic from '../../images/common/profile_icon_big.png';
import api from '../../api';
import closeBtn from '../../images/components/new_scan/close-btn.svg';

class FeedModal extends Component {
  constructor(props) {
    super(props);
    this.modalAction = null;
    this.modalBody = null;
    this.state = {
      isLoading: false,
      isOpenAlert: false,
      comment: '',
      commentList: props.commentList,
    };
    this.setReportFileComment = this.setReportFileComment.bind(this);
    this.setReportComponentComment = this.setReportComponentComment.bind(this);
    this.handleTextAreaChange = this.handleTextAreaChange.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.closeAlertModal = this.closeAlertModal.bind(this);
  }

  componentDidMount() {
  }

  componentDidUpdate(prevProps) {
    const { isOpenMFD, commentList } = this.props;
    if (isOpenMFD !== prevProps.isOpenMFD) {
      this.modalAction = null;
      this.modalBody = null;
      this.setState({
        commentList,
        comment: '',
        isOpenAlert: false,
      });
    }
  }

  handleTextAreaChange(e, { value }) {
    this.setState({
      comment: value,
    });
  }

  setReportFileComment() {
    const { uploadedFileId, scannedFileId, translate } = this.props;
    const { comment } = this.state;

    if (!comment.trim()) {
      this.modalAction = translate('modal.title.attention');
      this.modalBody = translate('modal.message.empty_comment_alert');
      this.setState({
        isOpenAlert: true,
      });
      return;
    }

    const data = {
      comment,
    };

    const obj = {
      uid: uploadedFileId,
      sfid: scannedFileId,
      data,
    };

    this.setState({
      isLoading: true,
    }, () => {
      api
        .setReportFileComment(obj)
        .then((res) => {
          const newComment = res.response;
          this.setState((prevState) => {
            return {
              isLoading: false,
              commentList: [newComment, ...prevState.commentList],
              comment: '',
            };
          });
        })
        .catch((err) => {
          console.log(err);
          this.setState({ isLoading: false });
        });
    });
  }

  setReportComponentComment() {
    const { uploadedFileId, currentComponentName, translate } = this.props;
    const { comment } = this.state;

    if (!comment.trim()) {
      this.modalAction = translate('modal.title.attention');
      this.modalBody = translate('modal.message.empty_comment_alert');
      this.setState({
        isOpenAlert: true,
      });
      return;
    }

    const data = {
      component_name: currentComponentName,
      comment,
    };

    const obj = {
      uid: uploadedFileId,
      data,
    };

    this.setState({
      isLoading: true,
    }, () => {
      api
        .setReportComponentComment(obj)
        .then((res) => {
          const newComment = res.response;
          this.setState((prevState) => {
            return {
              isLoading: false,
              commentList: [newComment, ...prevState.commentList],
              comment: '',
            };
          });
        })
        .catch((err) => {
          console.log(err);
          this.setState({ isLoading: false });
        });
    });
  }

  closeModal() {
    const { commentList } = this.state;
    const { closeModal } = this.props;
    closeModal(commentList);
  }

  closeAlertModal() {
    this.modalAction = null;
    this.modalBody = null;
    this.setState({
      isOpenAlert: false,
    });
  }

  render() {
    const {
      isOpenMFD,
      scannedFileName,
      currentComponentName,
      translate,
    } = this.props;

    const {
      isLoading,
      commentList,
      comment,
      isOpenAlert,
    } = this.state;

    const modalClassName = `more_info_popup feed${comment.trim() ? ' active' : ''}`;

    return (
      <Modal open={isOpenMFD} onClose={this.closeModal}>
        <div
          className={modalClassName}
        >
          <div className="popup_header" style={{ paddingBottom: '25px' }}>
            <Header as="h2">
              <Header.Content
                className="header_title"
              >
                {
                  scannedFileName && translate('modal.title.comment_list', { name: scannedFileName })
                }
                {
                  currentComponentName && translate('modal.title.comment_list', { name: currentComponentName })
                }
              </Header.Content>
            </Header>
            <a
              className="close_button"
              style={{ cursor: 'pointer' }}
              onClick={this.closeModal}
              onKeyUp={this.closeModal}
            >
              <img src={closeBtn} alt="" />
            </a>
          </div>
          <Scrollbars
            renderTrackHorizontal={() => {
              return <div />;
            }}
            renderThumbHorizontal={() => {
              return <div />;
            }}
            style={{
              height: '290px',
              overflow: 'hidden',
              position: 'relative',
            }}
          >
            <Feed>
              {
                commentList.length !== 0 ? (
                  commentList.map((item) => {
                    return (
                      <FeedEvent key={uuidv4()}>
                        <FeedLabel image={userPic} />
                        <FeedContent>
                          <FeedSummary>
                            <FeedUser>{item.creator}</FeedUser>
                            <FeedDate>{item.time}</FeedDate>
                          </FeedSummary>
                          <FeedExtra text>
                            {item.comment}
                          </FeedExtra>
                        </FeedContent>
                      </FeedEvent>
                    );
                  })
                ) : (
                  <div
                    style={{
                      textAlign: 'center',
                      color: '#888',
                      padding: '20px 0',
                      fontStyle: 'italic'
                    }}
                  >
                    {translate('modal.title.not_found_comment')}
                  </div>
                )
              }
            </Feed>
          </Scrollbars>
          <Form reply>
            <FormTextArea
              style={{ resize: 'none' }}
              rows={3}
              value={comment}
              onChange={this.handleTextAreaChange}
            />
            {comment.trim() && (
              <Button
                content={translate('modal.title.add_comment')}
                labelPosition="left"
                icon="edit"
                primary
                loading={isLoading}
                onClick={() => {
                  if (scannedFileName) {
                    this.setReportFileComment();
                  } else if (currentComponentName) {
                    this.setReportComponentComment();
                  }
                }}
              />
            )}
          </Form>
        </div>
        <Modal open={isOpenAlert} onClose={this.closeAlertModal}>
          <div className="modal_popup_wrap confirm_wrap">
            <div className="modal_popup_box confirm_box">
              <div className="modal_popup confirm">
                <h2 className="title">{this.modalAction}</h2>
                <p className="text">{this.modalBody}</p>
                <div className="button_wrap">
                  <a
                    className="center_button"
                    onClick={this.closeAlertModal}
                    onKeyUp={this.closeAlertModal}
                  >
                    {translate('modal.button.ok')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </Modal>
    );
  }
}

export default FeedModal;
